import "bkoi-gl/dist/style/bkoi-gl.css";
// import "mapbox-gl/dist/mapbox-gl.css";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import store from "./app/store";
import Loader from "./components/ui/Loader";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.css";
import "./styles/override.css";

// comment
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL!,
  realm: process.env.REACT_APP_KEYCLOAK_REALM!,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
});
// export const keycloak = new Keycloak({
//   url: "https://sso.dev-sheba.xyz",
//   realm: "master",
//   clientId: "digigo",
// });

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "check-sso",
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    onEvent={(event, error) => {
      // console.log(error);
    }}
    LoadingComponent={<Loader />}
  >
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ReactKeycloakProvider>
);

// root.render(
//   <ReactKeycloakProvider
//     authClient={keycloak}
//     initOptions={{
//       onLoad: "login-required",
//       pkceMethod: "S256",
//       checkLoginIframe: false,
//       redirectUri: window.location.origin + "/",
//     }}
//     onEvent={(event, error) => {
//       console.log(error);
//     }}
//     LoadingComponent={<Loader />}
//   >
//     <Provider store={store}>
//       <Router>
//         <App />
//       </Router>
//     </Provider>
//   </ReactKeycloakProvider>
// );

reportWebVitals();
